import { render, staticRenderFns } from "./ConfigName.vue?vue&type=template&id=3297e7e5&"
import script from "./ConfigName.vue?vue&type=script&lang=js&"
export * from "./ConfigName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3297e7e5')) {
      api.createRecord('3297e7e5', component.options)
    } else {
      api.reload('3297e7e5', component.options)
    }
    module.hot.accept("./ConfigName.vue?vue&type=template&id=3297e7e5&", function () {
      api.rerender('3297e7e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configurationManager/ConfigName.vue"
export default component.exports